$(document).on('turbolinks:load', function () {
  if ($("#solicitations-type-table").length) {
    $('#solicitations-type-table').DataTable({
      searching: true,
      serverSide: true,
      aLengthMenu: [
        [10, 25, 50, 100, 200],
        [10, 25, 50, 100, 200]
      ],
      iDisplayLength: 10,
      language: {
        "sLengthMenu": "Showing_MENU_",
        "info": "of _TOTAL_ Solicitation Types",
        "oPaginate": {
          "sFirst": "",
          "sLast": ""
        }
      },
      ajax: {
        url: $("#solicitations-type-table").data('source'),
      },
      pagingType: "full_numbers",
      "dom": "<'table-top'f><'table-responsive'rt><'table-bottom'<'table-count-info'li>p>",
      columns: [
        { data: "name" },
        { data: "abbreviation" },
        {
          data: "show_lpa_options",
          className: "text-center"
        },
        { data: 'updated_at' },
        {
          data: "dt_actions",
          className: "icon-wrap",
          orderable: false
        },
      ]
    });
  }
})
